import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Body, Image } from './styles';
export const Template = React.memo(({ alt, className, currentImageSource, focalImageFlag, previousImageSource }) => {
    return (_jsxs(Body, { className: className, children: [_jsx(Image, { alt: alt, isFocalImage: focalImageFlag, src: focalImageFlag ? currentImageSource : previousImageSource }), _jsx(Image, { alt: alt, isFocalImage: !focalImageFlag, src: !focalImageFlag ? currentImageSource : previousImageSource })] }));
});
//# sourceMappingURL=Template.js.map